// router
import React from 'react';
import { createBrowserRouter } from 'react-router-dom';

import Layout from './Components/Layout';
import HomePage from './Pages/HomePage';
import ProjectsPage from './Pages/ProjectsPage';
import WorkPage from './Pages/WorkPage';
import AboutPage from './Pages/AboutPage';
import ProjectPage from './Pages/ProjectPage';

const router = createBrowserRouter([
    {
        path: '/',
        element: <Layout />,
        children: [
            {
                path: '/',
                element: <HomePage />,
            },
            {
                path: '/projects',
                element: <ProjectsPage />,
            },
            {
                path: '/work',
                element: <WorkPage />,
            },
            {
                path: '/about',
                element: <AboutPage />,
            },
            // projects page
            {
                path: '/project/:slug',
                element: <ProjectPage />,
            }
        ],
    },
]);

export default router